import * as React from 'react';
import { navLink } from './skip-nav.module.css';

export const defaultContentId = `skip-to-content`;
export const defaultFooterId = `skip-to-footer`;

const focusTargetById = id => {
	const target = document.getElementById(id);

	if (!target) {
		return;
	}

	target.focus();
	target.scrollIntoView();

	if (window.history?.replaceState) {
		window.history.replaceState(null, '', `#${ id }`);
		return;
	}

	window.location.hash = id;
};

export function SkipNavLink({
	children = `Skip to content`,
	contentId,
	onClick,
	...props
}) {
	const id = contentId || defaultContentId;

	return (
		<a
			className={navLink}
			{...props}
			href={`#${ id }`}
			data-skip-to-content
			onClick={event => {
				onClick?.(event);

				if (event.defaultPrevented) {
					return;
				}

				event.preventDefault();
				focusTargetById(id);
			}}
		>
			{children}
		</a>
	);
}

/**
 * Wrap the main content of a page with this, thus also the <main> tag
 */
export function SkipNavContent({ children, id: idProp, ...props }) {
	const id = idProp || defaultContentId;
	const { tabIndex = -1 } = props;

	return (
		<main {...props} id={id} tabIndex={tabIndex}>
			{children}
		</main>
	);
}
